// Quick
export enum OUICK_ORDER_STATUS {
  ORDER_RECEIVED = '배송 접수',
  DRIVER_ASSIGNED = '배차 완료',
  PICKUP_COMPLETE = '픽업 완료',
  DELIVERY_COMPLETE = '배송 완료',
  ORDER_CANCELLED = '접수 취소'
}

export enum DeliveryStatus {
  PENDING = '배송 접수',
  ACTIVE = '배차 완료',
  CANCELLED = '접수 취소',
  INCOMPLETED = '부분 완료',
  COMPLETED = '배송 완료',
  RETURN = '회차'
}

export enum SearchQuickType {
  ORDERID = '예약번호',
  NAME = '발/수신자명'
}

export enum ProductSizeType {
  DOCUMENTS = '소량의 서류',
  SMALLBOX = '소형',
  BIGBOX = '대형',
  OTHERS = '기타'
}

export enum UserStatus {
  ACTIVE = '활성',
  INACTIVE = '일시중지'
}

export enum UserStatusChanged {
  WITHDRAW = '계정 탈퇴',
  INACTIVE = '계정 일시중지',
  ACTIVE = '계정 일시정지 해제'
}

export enum DormantUserStatus {
  ACTIVE = '활성 사용자',
  INACTIVE = '일시중지',
  WITHDRAW = '탈퇴'
}

export enum UserPermission {
  USER = '사용자',
  ADMIN = '관리자',
  SUPER = '최고 관리자'
}

export enum PaymentMethod {
  null = '지급 방식을 선택해주세요',
  YEAR = '연 단위 지급',
  MONTH = '월 단위 지급',
  EVENT = '1회성 이벤트'
}

export enum StatusType {
  DEAL = '거래',
  DEDUCTION = '차감',
  EXTINCTION = '소멸',
  PROVISION = '지급',
  CANCELDEAL = '취소거래'
}

export enum DateSearchType {
  REG = '신청일자로 검색',
  EXECUTE = '지급/차감일자로 검색'
}

// 김앤장 급여공제 회사지원비율
export enum KimAndChangCompanySupportRate {
  SIXTY_FIVE_PERCENT = 0.65, // 65% 지원
  SEVENTY_SIX_POINT_SEVEN_PERCENT = 0.767 // 76.7% 지원
}

export enum WelcomeSystemINCCompanySupportRate {
  FORTY_FIVE_PERCENT = 0.45, // 45% 지원
  FORTY_PERCENT = 0.4 // 40% 지원
}

export enum VENDYS_SERVICES {
  MEAL = '식권대장',
  WELFARE = '복지대장',
  QUICK = '퀵대장',
  GROUP_GIFT = '단체선물대장',
  ADVERTISE = '광고대장',
  FOOD_TRUCK = '푸드트럭대장',
  COMPULSORY_EDUCATION = '의무교육대장',
  PAY_HERE = '페이히어',
  ETC = '기타'
}
